exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IconInfo_iconInfo_1IFrK{cursor:pointer;-webkit-transition:fill .2s ease-out;transition:fill .2s ease-out}", ""]);

// exports
exports.locals = {
	"iconInfo": "IconInfo_iconInfo_1IFrK"
};